var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:none;}.c{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff52a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90353"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1035 -6095)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-160 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(1195 6135)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1052 6112)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H46V46H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.778,2A18.778,18.778,0,1,0,39.556,20.778,18.785,18.785,0,0,0,20.778,2Zm1.878,28.167H18.9V18.9h3.756Zm0-15.022H18.9V11.389h3.756Z",
    transform: "translate(2.222 2.222)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.027dd4650ef723af8281c3ffa5e59080.svg";
export { ForwardRef as ReactComponent };